
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from './controlador';
    import item from './facturacion-item.vue';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            item,

        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Vue.observable( Model ); }
        public get Vista() { return this.Controlador.Vista; }

        @Prop()
        public Pedido: Pedido;

        @Prop()
        public Abrir: boolean;
        @Watch( 'Abrir' )
        onAbrir()
        {
            this.Abierto = false;
            if ( this.Pedido)
            {
                this.$nextTick( () => this.Abierto = true );
                this.Controlador.Iniciar( [this.Pedido] )
            }
        }

        public Abierto: boolean = false;
        public Cargando: boolean = false;


        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async DescargarFacturas()
        {
            this.Cargando = true;
            let pdf = await Pedido.URLFacturas( this.Controlador.Operaciones.map( x => x.Pedido) );
            if ( pdf )
            {
                window.open( pdf );
            } else
            {
                Utiles.Notificaciones.Error( `Error al descargar la factura` );

            }
            this.Cargando = false;

        }

        async Iniciar()
        {
            if ( this.Controlador.Operaciones.hasRows() )
            {
                this.Cargando = true;
                await this.Controlador.Operaciones[0].Iniciar();
                this.Cargando = false;

                if ( this.Controlador.Operaciones[0].Errores && this.Controlador.Operaciones[0].Errores.hasRows() )
                {
                    Utiles.Mensajes.Aceptar( 'Se encontraron errores.', this.Controlador.Operaciones[0].Errores.join( ', ' ) );
                } else
                {
                    this.Controlador.Ejecutar();
                }
            }
            
        }
    }
